import { ChatSource } from '@/types'

export interface ChatMessageContext {
  type: 'folder' | 'file'
  id: number
  name: string
}

export interface ChatMessage {
  id: string
  type: 'user' | 'assistant'
  content: string
  timestamp: Date
  context?: ChatMessageContext
  suggestedQuestions?: string[]
  sources?: ChatSource[]
  /** Set when an answer didn't finish: the user stopped it, or the stream failed. */
  status?: 'stopped' | 'interrupted'
  /** Notices (errors, quota messages) shown in the chat but never sent back as conversation history. */
  excludeFromHistory?: boolean
}

/**
 * The last turns to send as `conversation_history`: real user/assistant messages only.
 */
export function toConversationHistory(
  messages: Array<{ type: string; content: string; excludeFromHistory?: boolean }>,
  limit = 40
): Array<{ type: 'user' | 'assistant'; content: string }> {
  return messages
    .filter(
      (m): m is { type: 'user' | 'assistant'; content: string; excludeFromHistory?: boolean } =>
        (m.type === 'user' || m.type === 'assistant') &&
        !m.excludeFromHistory &&
        m.content.trim() !== ''
    )
    .slice(-limit)
    .map(({ type, content }) => ({ type, content }))
}
